import { Navigate } from '@exam-management/router';

export default function ExamCourseGateway() {
  return <Navigate to='/exam-courses' />;
}
